// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seo-pages-header[data-v-5de3813e]{box-sizing:border-box;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
